<div class="compare-info">
  <span class="version">v.{{version1}}</span><span aria-hidden="true">&nbsp;{{compareInfo}}&nbsp;</span><span class="version">v.{{version2}}</span>
</div>
